
// src/connects/group-sorting-page.js

import { connect } from 'react-redux'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { sortArray, stripArray } from '../helpers/store'
import { translate } from 'react-i18next'
import filter from 'lodash/filter'
import _ from'lodash'


export const mapStateToProps = (state)=> {
    return {
      groups: state.groups.items,
      divisions: state.divisions.items,
      menuItems: state.menus.items,
      flashNewFreeGroupId: state.menus.flashNewFreeGroupId,
      sortingMenu: state.menus.sortingMenu,
      expandedDivisionSort: state.menus.expandedDivisionSort,
      userMenuItems: state.user && state.user.current ? state.user.current.menu_items : null,
      canExpandDivSortNotSetGroup: state.menus.canExpandDivSortNotSetGroup
    }
}

export const mergeProps = (stateProps, dispatchProps)=> {
    var groups = stateProps.groups
    var memberGroups = filter(groups, (group)=> {
      return (group.is_member || group.favorite)
    })

    return {
      ...stateProps, ...dispatchProps,
      MemberGroups: stripArray(memberGroups),
    }
}

export const mapDispatchToProps = (dispatch)=> {
    return {
        setNewMenuPositions: (newPositions) => {
          dispatch(actions.setNewMenuPositions(newPositions))
        },
        sortMenu: (oldPosition, newPosition) => {
            dispatch(actions.sortMenu(oldPosition, newPosition))
        },
        setFreeMenu: (menuItem) => {
            dispatch(actions.setFreeMenu(menuItem.position))
            dispatch(actions.setFlashNewFreeGroupId(menuItem.item_id))
            setTimeout(() => dispatch(actions.setFlashNewFreeGroupId(null)), 2000);
        },
        setSortingMenuPosition: (position) => {
          dispatch(actions.setSortingMenuPosition(position))
        },
        setNotFreeMenu: (position, groupDivisionIds) => {
            dispatch(actions.setNotFreeMenu(position, groupDivisionIds))
        },
        expandDivisionSort: (division_id) => {
          dispatch(actions.expandDivisionSort(division_id))
        },
        collapseDivisionSort: (division_id) => {
            dispatch(actions.collapseDivisionSort(division_id))
        },
        willMount: (props)=> {
          dispatch(actions.initMenus(props.userMenuItems, props.divisions, props.groups))
        },
        willUpdate: (props, nextProps)=> {
          if (!_.isEqual(props.menuItems, nextProps.menuItems))
            dispatch(actions.updateUserMenuItems(nextProps.menuItems))
        },
        expandDivisionSortNotSetGroup: ()=> {
            dispatch(actions.expandDivisionSortNotSetGroup())
        }
    }
}

export default combineHOC(
    connect(mapStateToProps, mapDispatchToProps, mergeProps),
    lifecycle,
    translate(),
)



// WEBPACK FOOTER //
// ./src/connects/group-sorting-panel.js